import {
  MESSAGETEMPLATESELECTDATA,
  TEMPLATESELECTDATA,
  SETTITLEDATA,
  SETPHONEMESSAGEDATA,
  SETSMSMESSAGEDATA,
  SETEMAILMESSAGEDATA,
  SETENGLISHPOSITIVERESPONSEDATA,
  SETENGLISHNEGATIVERESPONSEDATA,
  SETSPANISHPOSITIVERESPONSEDATA,
  SETSPANISHNEGATIVERESPONSEDATA,
  FETCH,
  SELECTIONDATA,
} from './actionType'

// initialState shows what we are going to change
const initialState = {
  inputAddEntryData: '',
  data: null,
  // API call
  fetching: false,
  inputTitleData: '',
  inputPhoneMessageData: '',
  inputSMSMessageData: '',
  inputEmailMessageData: '',
  inputEnglishPositiveResponseData: '',
  inputEnglishNegativeResponseData: '',
  inputSpanishPositiveResponseData: '',
  inputSpanishNegativeResponseData: '',
  selectionData: {},
}

// Checks the type of the action and returns the appropriate state
export default function messageTemplateSelectCreateReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case FETCH:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching,
      })
    case SELECTIONDATA:
      // Update selection data for consistency
      return Object.assign({}, state, {
        selectionData: action.data,
      })
    case MESSAGETEMPLATESELECTDATA:
      // Populate Message Template
      return Object.assign({}, state, {
        data: action.data,
      })
    case TEMPLATESELECTDATA:
      // Update to Message Template List, either add or remove
      return Object.assign({}, state, {
        inputAddEntryData: '',
        data: action.data,
      })
    case SETTITLEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputTitleData: action.data,
      })
    case SETPHONEMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputPhoneMessageData: action.data,
      })
    case SETSMSMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputSMSMessageData: action.data,
      })
    case SETEMAILMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputEmailMessageData: action.data,
      })
    case SETENGLISHPOSITIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputEnglishPositiveResponseData: action.data,
      })
    case SETENGLISHNEGATIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputEnglishNegativeResponseData: action.data,
      })
    case SETSPANISHPOSITIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputSpanishPositiveResponseData: action.data,
      })
    case SETSPANISHNEGATIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputSpanishNegativeResponseData: action.data,
      })
    default:
      // returns state as is without changes
      return state
  }
}
